module.exports = __webpack_public_path__ + "img/ClickForSound_19.6d35d010.png";